export default "__VITE_ASSET__3f3907c7__"